import { takeEvery, put, call, SagaReturnType } from 'redux-saga/effects';
import { LOADER_OFF, LOADER_ON, PatientPayersActions } from 'src/redux/actions/constant';

import patientService from 'src/services/apiServices/patientService';

const {
  GET_ALL_PATIENT_PAYER_REQUEST,
  GET_ALL_PATIENT_PAYER_SUCCESS,
  GET_ALL_PATIENT_PAYER_FAILURE,
} = PatientPayersActions;

function* getAllPatientPayers(action: any): SagaReturnType<any> {
  try {
    const response = yield call(patientService.getAllPatientPayers, action.payload);
    if (response?.status === 200) {
      yield put({ type: GET_ALL_PATIENT_PAYER_SUCCESS, payload: response.data });
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({ type: GET_ALL_PATIENT_PAYER_FAILURE, payload: error });
  } finally {
  }
}

function* getAllPatientPayersSaga() {
  yield takeEvery(GET_ALL_PATIENT_PAYER_REQUEST, getAllPatientPayers);
}

export default getAllPatientPayersSaga;
